// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ConfirmController from "./confirm_controller"
application.register("confirm", ConfirmController)

import SearchController from "./search_controller"
application.register("search", SearchController)
